import { writeContract } from '@wagmi/core';
import { getMarketplaceContract } from '@/constants/marketplace/contracts';
import { marketplaceV3Abi as directListingsAbi } from '@/constants/abi/marketplaceV3Abi'
import type { ChainType } from '@/constants/chain-specific';
import { config } from '@/config/index'; // Assuming this is your wagmi config

interface CancelListingParams {
  listingId: bigint;
  chainId: ChainType;
}

/**
 * Function to cancel a direct listing.
 */
export async function cancelListingOnNFT({
  listingId,
  chainId,
}: CancelListingParams) {
  const marketplaceContract = getMarketplaceContract(chainId);
  const contractAddress = marketplaceContract?.address;

  if (!contractAddress) {
    throw new Error(`No marketplace contract found for chain ID ${chainId}`);
  }

  try {
    const result = await writeContract(config, {
      address: contractAddress,
      abi: directListingsAbi, // Use directListingsAbi
      functionName: 'cancelListing',
      args: [listingId],
      chainId,
    });
    return result;
  } catch (error) {
    console.error('Error cancelling listing:', error);
    throw error;
  }
}
